import { useDispatch, useSelector } from "react-redux";

import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

import { SomDbViewModesEnum } from "core/enums";
import { getUserPermissions } from "slices/auth";
import { getSomDbStatisticView } from "slices/somDb/somDbSelectors";
import { somDbActions } from "slices/somDb/somDbSlice";

import { CharColumnsButton } from "./CharColumnsButton/CharColumnsButton";
import { DataFilterGroup } from "./DataFilterGroup/DataFilterGroup";

export const viewModes = [SomDbViewModesEnum.FLAT, SomDbViewModesEnum.NESTED, SomDbViewModesEnum.MULTI_NESTED];

const SomDbRibbonSettings = ({
	selectedClassifier,
	setSelectedClassifier,
	classifierOptions,
	selectedViewMode,
	setSelectedViewMode,
	setShowColumnsDialog,
	setSearchValue,
	selectedStatus,
	setSelectedStatus,
	checkedColumnsCount,
}) => {
	const dispatch = useDispatch();
	const userPermissions = useSelector(getUserPermissions);
	const statisticView = useSelector(getSomDbStatisticView);

	return [
		{
			name: "Режимы просмотра",
			_children: [
				{
					orientation: "vertical",
					_children: [
						{
							type: "controlled-radio",
							value: selectedViewMode,
							setValue: setSelectedViewMode,
							isDisabled: statisticView,
							radioArray: [
								{
									name: "Список",
									value: viewModes[0],
								},
								{
									name: "Таблица",
									value: viewModes[1],
								},
								{
									name: "Дерево",
									value: viewModes[2],
								},
							],
						},
					],
				},
			],
		},
		{
			name: "Представление",
			_children: [
				{
					orientation: "vertical",
					_children: [
						{
							name: "Классификатор",
							type: "autocomplete",
							value: selectedClassifier,
							setValue: setSelectedClassifier,
							options: classifierOptions,
							styles: { width: "200px" },
						},
						{
							type: "custom",
							customJsx: (
								<CharColumnsButton
									disabled={statisticView}
									checkedColumnsCount={checkedColumnsCount}
									showColumnsDialog={() => setShowColumnsDialog(true)}
								/>
							),
							styles: { pt: "3px" },
						},
					],
				},
			],
		},
		{
			name: "Фильтр данных",
			_children: [
				{
					orientation: "vertical",
					_children: [
						{
							type: "custom",
							customJsx: (
								<DataFilterGroup
									disabled={statisticView}
									setSearchValue={setSearchValue}
									selectedStatus={selectedStatus}
									setSelectedStatus={setSelectedStatus}
								/>
							),
							styles: {
								width: "300px",
								pt: "7px",
							},
						},
					],
				},
			],
		},
		{
			name: "Статистика",
			isVisible: userPermissions.is_som_admin === true,
			_children: [
				{
					orientation: "vertical",
					_children: [
						{
							name: "По разд. содержания",
							icon: <AssessmentOutlinedIcon />,
							size: "large",
							type: "common",
							active: statisticView,
							callback: () => {
								setSelectedViewMode(SomDbViewModesEnum.MULTI_NESTED);
								if (!statisticView) {
									dispatch(somDbActions.setStatisticView(true));
								} else {
									dispatch(somDbActions.setStatisticView(false));
								}
							},
						},
					],
				},
			],
		},
	];
};

export default SomDbRibbonSettings;
